import { Component, Input, OnInit } from '@angular/core';
import { BuildListService } from '../../buildlist/buildlist.service';
import { IBuildList } from '../../shared/buildList';
import { IWorkItem } from '../../shared/workItem';

@Component({
  selector: 'app-save-list',
  templateUrl: './save-list.component.html',
  styleUrls: ['./save-list.component.css']
})
export class SaveListComponent implements OnInit {

  @Input() workitems: IWorkItem[];
  public buildLists: IBuildList[];
  public showTextbox: boolean = true;
  buildListName: string;
  selNewOrExist: string = "0";

  constructor(private data: BuildListService) { }

  ngOnInit() {
    //TODO Comment this out so Victor doesn't run into Sql Error
    this.loadBuildDropDown(); 
  }

  loadBuildDropDown() {
    this.data.loadBuildLists()
      .subscribe(data => {
          this.buildLists = data;
      });
  }

  selectedChangeHandler(event: any) {
    this.selNewOrExist = event.target.value;
    if (this.selNewOrExist == "0")
      this.toggleNewOrExisting(true);
    else {
      this.toggleNewOrExisting(false);
    }
  }

  handleBuildList() {
    if (this.selNewOrExist != "0") {
      //update
      let newList: IBuildList = {
        name: 'this is a test',
        workItems: this.workitems
      };

      this.data.addToBuildList(this.selNewOrExist, newList)
        .subscribe(() => {
          this.loadBuildDropDown();
          this.toggleNewOrExisting(true);
        })
    }
    else {
      //create new
      let newList: IBuildList = {
        name: this.buildListName,
        workItems: this.workitems
      };

      this.data.createBuildList(newList)
        .subscribe(() => {
          this.loadBuildDropDown();
          this.toggleNewOrExisting(true);
        })
    }
  }

  toggleNewOrExisting(show: boolean) {
    this.showTextbox = show;
    this.buildListName = '';
  }

}
